import { c as _c } from "react/compiler-runtime";
import type { ComparisonTableColumn } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import Grid from '@mui/material/Grid';
import type { Ref } from 'react';
import { useReviewContext } from '../../../Context';
import { MAXIMUM_COLUMNS_MOBILE } from '../Context';
import ApplyNowCta from './ApplyNowCta';
import CardAndRating from './CardAndRating';
type ComparisonTableHeaderProps = {
  column: ComparisonTableColumn;
  index: number;
  innerRef: Ref<HTMLDivElement>;
};
export default function ComparisonTableHeader(t0) {
  const $ = _c(16);
  const {
    column,
    index,
    innerRef
  } = t0;
  const {
    isPrimaryEntity
  } = column;
  const {
    marketplaceEntity: t1
  } = useReviewContext();
  const {
    id: reviewMarketplaceId
  } = t1;
  const columnMarketplaceId = column.marketplaceEntity.id;
  const shouldShowReviewLink = reviewMarketplaceId !== columnMarketplaceId;
  const t2 = isPrimaryEntity ? 5 : 0;
  const t3 = isPrimaryEntity ? "2" : "1";
  const t4 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t5;
  if ($[0] !== t4) {
    t5 = {
      md: "flex",
      xs: t4
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = index === 0 ? 1 : 0;
  const t7 = `header-container-${index}`;
  let t8;
  if ($[2] !== column || $[3] !== shouldShowReviewLink) {
    t8 = <CardAndRating column={column} shouldShowReviewLink={shouldShowReviewLink} />;
    $[2] = column;
    $[3] = shouldShowReviewLink;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== column) {
    t9 = <ApplyNowCta column={column} />;
    $[5] = column;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== innerRef || $[8] !== t2 || $[9] !== t3 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <Grid boxShadow={t2} zIndex={t3} display={t5} alignItems="center" borderLeft={t6} borderRight={1} borderBottom={1} flex={1} flexDirection="column" justifyContent="space-between" data-testid={t7} borderColor="neutral.light" ref={innerRef} size={12}>{t8}{t9}</Grid>;
    $[7] = innerRef;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}